import { em, math } from 'polished'
import styled, { css } from 'styled-components'

import { transitionFade } from 'styles/mixins_styled/transition'

const cardWidthMd = em(380)

export const Form = styled.form`
  position: relative;
  padding: ${p => p.theme.indents.baseIndentXs} ${p =>
  p.theme.indents.baseIndentXs} 0;
  margin-left: -${p => p.theme.indents.baseIndentXs};
  margin-right: -${p => p.theme.indents.baseIndentXs};
  transition: background-color ${p => p.theme.animation.timeStandard} ease-in;

  &:after {
    display: table;
    content: '';
    clear: both;
    height: 0;
  }

  background: ${p => p.theme.colors.grayOp06NonTransp};
  border-radius: ${em(10)};

  ${({ cardType }) =>
    cardType === 'visa' &&
    css`
      background-color: #01539f;
    `}

  ${({ cardType }) =>
    cardType === 'mastercard' &&
    css`
      background-color: ${p => p.theme.colors.blackOp07};
    `}

  ${({ cardType }) =>
    cardType === 'amex' &&
    css`
      background-color: #1997c4;
    `}

  ${p => p.theme.mq.upMd} {
    border-radius: 0;
    background: transparent !important;
    padding: 0;
    width: ${math(`${cardWidthMd} * 1.46`)};
    max-width: 100%;
    margin: 0 auto ${em(30)};
  }
`

export const BrandWrapper = styled.div`
  position: absolute;
  right: ${em(20)};
  top: ${em(20)};
  display: flex;
  height: ${em(50)};
  align-items: center;

  ${p => p.theme.mq.upMd} {
    position: absolute;
    top: initial;
    bottom: ${em(40)};
    right: ${em(30)};
    height: auto;
  }

  ${transitionFade};
`

export const ExpiryBlock = styled.div`
  width: 50%;
  padding-right: ${em(20)};

  ${p => p.theme.mq.upMd} {
    width: ${em(120)};
    padding-right: 0;
  }
`

export const CvcBlock = styled.div`
  width: 50%;
  padding-left: ${em(20)};
  pointer-events: all;

  ${p => p.theme.mq.upMd} {
    padding-left: ${em(56)};
    padding-top: ${em(50)};
    padding-right: ${em(17)};
  }

  ${p => p.theme.mq.upLg} {
    width: ${em(79)};
    padding-left: ${em(20)};
    padding-right: 0;
  }

  ${p => p.theme.mq.upThreshold(1240)} {
    width: 50%;
    padding-left: ${em(56)};
    padding-right: ${em(17)};
  }
`

export const Card = styled.div`
  transition: background-color ${p => p.theme.animation.timeStandard} ease-in;

  ${({ isBack }) =>
    isBack &&
    css`
      display: flex;
      position: absolute;
      width: 100%;
      bottom: 0;
      right: ${p => p.theme.indents.baseIndentXs};
      justify-content: flex-end;
      pointer-events: none;
    `}

  ${p => p.theme.mq.upMd} {
    width: ${cardWidthMd};
    height: ${em(230)};
    border-radius: ${p => p.theme.blocks.blockBorderRadiusForm};
    padding: ${em(35)} ${em(40)} ${em(40)};

    ${({ isFront, cardType }) =>
      isFront &&
      css`
      position: relative;
      background: ${p => p.theme.colors.white};
      z-index: 10;
      box-shadow: 5px 25px 25px rgba(0, 0, 0, 0.1);

      ${cardType === 'mastercard' &&
        css`
          background: ${p => p.theme.colors.white};
        `}

      ${cardType === 'visa' &&
        css`
          background: #01539f;
        `}

      ${cardType === 'amex' &&
        css`
          background: #1997c4;
        `}
    `}

    ${({ isBack, cardType }) =>
      isBack &&
      css`
      pointer-events: all;
      bottom: auto;
      top: ${em(50)};
      right: 0;
      background: ${p => p.theme.colors.white};
      z-index: 9;

      ${cardType === 'mastercard' &&
        css`
          background: ${p => p.theme.colors.white};
        `}

      ${cardType === 'visa' &&
        css`
          background: #00498d;
        `}

      ${cardType === 'amex' &&
        css`
          background: #1b7da2;
        `}
    `}
  }
`

export const IconBlock = styled.div`
  width: ${p => p.iconWidth};
  height: ${p => p.iconHeight};
`
